import React from 'react';
import { Link } from 'react-router-dom';
import './HistoricalDataCTA.css';

const HistoricalDataCTA = () => {
  return (
    <section className="historical-cta-section">
      <div className="historical-cta-container">
        <div className="historical-cta-content">
          <h2>Historical data that powers today's decisions</h2>
          <p>
            Access 20+ years of curated data and over 1,500 structured data sets empowering you to analyze past trends, anticipate market shifts, and make informed decisions in a long-range context.
          </p>
        </div>
        <div className="historical-cta-button">
          <Link to="/Signup">
            <button>Get access to the data</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HistoricalDataCTA;